import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginState } from '../model/LoginState';
import { Utils } from '../utils';
import { AuthenticationService } from './authentication.service';
import { EventService } from './event.service';
import { Events, MsgPayLoad } from './websocket.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  private skipGenericErrorList: string[] = [
    "activity/cancelActivity",
    "activity/deleteAllActivities",
    "managers/upload",
    "auth/testOtdsConnection",
    "auth/activateResource",
    "auth/saveAuthenticationConfig",
    "auth/getOtdsGroups",
    "managers/general/repairManifest",
    "managers/update/checkManifestUpdate",
    "auth/signout",
    "update/extractUpdate",
    "update/applyUpdate",
    "softwareinventory/productLogs",
    "softwareinventory/adminSettings",
    "patches/available",
    "hotfixes/available",
    "product/authenticate",
    "product/authenticate/info",
    "product/discover",
    "product/sync/capabilities",
    "product/resync",
    "product/analyze",
    "product/analysis/quick",
    "product/disable",
    "product/analysis/update",
    "product/patchable",
    "product/preflight",
    "product/registered/servers",
    "product/upgrade/prompts",
    "product/remove/instances",
    "agent/remove",
    "agent/enable",
    "validate/host",
    "activity/capabilities",
    "patch/install",
    "software/rollback",
    "plugin/products",
    "discover/prompts",
    "discover/validate",
    "discover/landscape",
    "solution",
    "environment",
    "auth/SFTP",
    "support/logs",
    "support/SFTP",
    "user/createUser",
    "download/zip",
  ];

  constructor(public router: Router, public authService: AuthenticationService, public eventService: EventService, public storageService: StorageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newParams = new HttpParams({
      fromString: req.params.toString(),
      encoder: this,
    });
    
    req = this.isAuthRequest(req.url) ? req.clone({ params: newParams, withCredentials: false}): req.clone({ params: newParams, withCredentials: true });

    return next.handle(req).pipe(
      catchError((error) => {
        //log console error
        console.error(error?.message);

        //if forbidden
        if (error.status === 403) {
          if (!this.isAuthRequest(req.url)) {
            if(!this.isExpected403Error(req.url)){
              //check if the session has expired
              if (error.error.status && error.error.status.errorCode === 'ERROR_SESSION_EXPIRED') {
                let msg = new MsgPayLoad(undefined, {});
                msg.setEvent(Events.SessionExpired);
                msg.eventType = Events.SessionExpired;
                this.storageService.clean();
                this.eventService.broadcastEventMessage(msg);
              } else {
                this.eventService.broadcastLoginStateChange(LoginState.Forbidden);
              }
            }
          }
          //show server error
        } else {
          if (this.isGenericError(req.url)) {
            Utils.addHeaderMessageEventBanner(this.eventService, Events.ServerError, $localize`The server encountered an error. Please try again later or contact your system administrator.`);
          }
        }
        return throwError(error);
      })
    )
  }

  private isAuthRequest(url: string): boolean {
    return (url.indexOf("auth/authenticate") > 0);
  }

  private isGenericError(url: string): boolean {
    let isGeneric = true;

    this.skipGenericErrorList.forEach(fragment => {
      if (url.indexOf(fragment) > 0) {
        isGeneric = false;
        return;
      }
    });

    return isGeneric;
  }

  private isExpected403Error(url: string): boolean {
    return (url.indexOf("managers/solution/getPlan/") > 0);
  }

  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
